import { render, staticRenderFns } from "./aboutSwiper.vue?vue&type=template&id=29af99cf&scoped=true&"
import script from "./aboutSwiper.vue?vue&type=script&lang=js&"
export * from "./aboutSwiper.vue?vue&type=script&lang=js&"
import style0 from "./aboutSwiper.vue?vue&type=style&index=0&id=29af99cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29af99cf",
  null
  
)

export default component.exports